export const LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'es',
        name: 'Español',
        country_code: 'es'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'zh',
        name: '中文',
        country_code: 'cn'
    },
]

export const LHR_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'es',
        name: 'Español',
        country_code: 'es'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'zh',
        name: '中文',
        country_code: 'cn'
    },
    {
        code: 'de',
        name: 'German',
        country_code: 'de'
    },
    {
        code: 'fr',
        name: 'French',
        country_code: 'fr'
    },
]

export const SBTP_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'de',
        name: 'German',
        country_code: 'de'
    }
]

export const COC_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'es',
        name: 'Español',
        country_code: 'es'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'zh',
        name: '中文',
        country_code: 'cn'
    },
    {
        code: 'de',
        name: 'German',
        country_code: 'de'
    },
    {
        code: 'fr',
        name: 'French',
        country_code: 'fr'
    },
]

export const COO_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'fr',
        name: 'French',
        country_code: 'fr'
    },
]


export const TPS_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'es',
        name: 'Español',
        country_code: 'es'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'zh',
        name: '中文',
        country_code: 'cn'
    }
]

export const CBAM_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
        country_code: 'us'
    },
    {
        code: 'fr',
        name: 'French',
        country_code: 'fr'
    },
    {
        code: 'pt',
        name: 'Português',
        country_code: 'pt'
    },
    {
        code: 'zh',
        name: '中文',
        country_code: 'cn'
    },
    {
        code: 'es',
        name: 'Español',
        country_code: 'es'
    },
    {
        code: 'de',
        name: 'German',
        country_code: 'de'
    },
]